export default __webpack_public_path__ + "static/media/back.9bf2f417.png";